import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { usePopper } from "react-popper";
import { ClickAwayListener, Box } from "@mui/material";
import Tooltip from "../Popper/Tooltip";
const CustomPopover = ({ children, content, anchorEl, handleClose }) => {
    const [referenceElement, setReferenceElement] = useState(anchorEl);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const { styles: popperStyles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [
            { name: "arrow", options: { element: arrowElement } },
            {
                name: "offset",
                options: {
                    offset: [0, 16],
                },
            },
        ],
    });
    const [open, setOpen] = useState(referenceElement ? true : false);
    const togglePopover = () => {
        setOpen(!open);
    };
    const onClickAway = () => {
        if (handleClose)
            handleClose();
        else
            setOpen(false);
    };
    return (_jsxs(Box, { children: [children && React.cloneElement(children, Object.assign(Object.assign({}, children.props), { ref: setReferenceElement, onClick: togglePopover })), open && referenceElement && (_jsxs(Tooltip, Object.assign({ ref: setPopperElement, style: popperStyles.popper }, attributes.popper, { children: [_jsx("div", { ref: setArrowElement, className: "arrow", style: popperStyles.arrow }), _jsx(ClickAwayListener, Object.assign({ onClickAway: onClickAway }, { children: _jsx("div", Object.assign({ style: { position: "relative", padding: "8px", backgroundColor: "#fff", borderRadius: "4px" } }, { children: content })) }))] })))] }));
};
export default CustomPopover;
